import { Injectable } from '@angular/core'
import { MbWishlistAdapter } from './mb-wishlist.adapter'

@Injectable({
  providedIn: 'root',
})
export class MbWishlistConnector {

  constructor (protected adapter: MbWishlistAdapter) { }

  getDefaultWishlist (userId: string) {
    return this.adapter.loadDefaultWishlist(userId)
  }

  addEntryToWishlist (productCode: string, userId: string) {
    return this.adapter.addEntryToWishlist(productCode, userId)
  }

  removeEntryFromWishlist (productCode: string, userId: string) {
    return this.adapter.removeEntryFromWishlist(productCode, userId)
  }
}
